module.exports = __webpack_public_path__ + "img/placeholder-f.6d5fa477.png";